import { Spinner } from 'reactstrap';

export default ({ width = '3rem', color = 'primary' }) => (
  <Spinner style={{ width, height: width }} name="ball-triangle-path" color={color} />
)
